import React from 'react';
import Typography from '@material-ui/core/Typography';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {withRouter} from 'react-router-dom';
import AppAnimate from "../AppAnimate/index"
import withWidth from "@material-ui/core/withWidth/withWidth";
import {connect,} from "trim-redux";
import Grid from "@material-ui/core/Grid/Grid";
import queryString from "query-string";
import {defaultVariabls} from "../../../config";
import axios from "axios";
import {Translate} from "../../../config/Translate";

class AuthLayout extends React.Component {
    constructor(props){
        super(props);
        const values = queryString.parse(this.props.location.search)
        let redirect = values.r;
        if(this.props.isAuth){
            this.props.history.push("/");
        }
        if(!!redirect){
            this.state={
                redirect: redirect,
                data:null,
                loading:true,
            };
            localStorage.setItem("external_redirect",this.state.redirect);
        }else{
            this.state={
                redirect: null,
                data:null,
                loading:true,
            };
        }
    }
    componentDidMount() {
        this.loadData();
    }
    async loadData(){
        let config = {
            headers: {
                Accept: 'application/json',
            }
        };
        await axios.get(`${defaultVariabls.url}/get-auth-info`, config)
            .then(response => {
                this.setState({
                    data:response.data,
                    loading:false,
                })
            }).catch(error => {
                console.log(error.response)

            })

    }
    render() {
        const children = this.props.children;
        const {classes,primary_color,logo,app_name,about,setting} = this.props;
        let {data,loading} = this.state;

        return (
            <div className="authContainer">
                <div className={classes.auth_container}>
                    <a href={`${defaultVariabls.website}/shop`}>
                        <img
                            src={`${defaultVariabls.website}/images/epanjere/panjere-logo.png`}
                            alt={app_name}
                            className={classes.auth_logo}
                        />
                    </a>

                    <Typography
                        className={classes.auth_about_desc}
                    >
                        {about.short_description}
                        <div className="loader-search">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </Typography>
                    <AppAnimate animation='transition.slideUpIn' delay={200}>
                        <div className={classes.auth_inner} >
                            <div className={classes.auth_container_items}>
                                <Grid container spacing={2} justifyContent='center' alignItems="center">
                                    {children}
                                </Grid>
                            </div>
                            {
                                !!setting &&
                                <>
                                    {
                                        !!setting.login_info &&
                                        <div className={classes.auth_container_data_items}>
                                            <div className={classes.single_item}>
                                                <Typography>{Translate.active_users}
                                                    {
                                                        !loading &&
                                                        <strong>{data.active_users}</strong>
                                                    }
                                                </Typography>
                                            </div>
                                            <div className={classes.single_item}>
                                                <Typography>{Translate.registered_books}
                                                    {
                                                        !loading &&
                                                        <strong>{data.registered_books}</strong>
                                                    }
                                                </Typography>
                                            </div>
                                            <div className={classes.single_item}>
                                                <Typography>{Translate.succsessfull_sales}
                                                    {
                                                        !loading &&
                                                        <strong>{data.succsessfull_sales}</strong>
                                                    }
                                                </Typography>
                                            </div>
                                            <div className={classes.single_item}>
                                                <Typography>{Translate.online_users}
                                                    {
                                                        !loading &&
                                                        <strong>{data.online_users}</strong>
                                                    }
                                                </Typography>
                                            </div>
                                        </div>
                                    }
                                </>
                            }

                        </div>
                    </AppAnimate>
                </div>
            </div>
        );

    }
}
const mstp = state => ({
    primary_color: state.primary_color,
    logo: state.logo,
    app_name: state.app_name,
    about: state.about,
    setting: state.setting,
});
export default withWidth()(withStyles(Styles)(withRouter(connect(mstp)(AuthLayout))));